/**
 * Explain, in plain language, why the layout-preserving PDF→Office conversion
 * couldn't run — so the text-only fallback is shown as a labeled downgrade
 * rather than silently handed back as if it were the product's best output.
 *
 * @param {Error|null|undefined} err  the error thrown by the convert engine
 * @returns {string} a user-facing reason
 */
export function describeConvertFallback(err) {
  const msg = (err && (err.message || String(err))) || '';
  // A server-side failure (cloudbridge attaches a numeric .status on non-2xx)
  // is transient — tell the user to retry rather than implying a permanent gap.
  if (err && typeof err.status === 'number' && err.status >= 500) {
    return 'The conversion service is temporarily unavailable — please try again in a moment. We extracted the text instead.';
  }
  if (/sign|auth|unauthor|401|403|log ?in|account/i.test(msg)) {
    return 'Full layout-preserving conversion needs a signed-in account. We extracted the text instead.';
  }
  if (/network|offline|fetch|connect|timeout|ENOTFOUND|ECONN|dns/i.test(msg)) {
    return 'Full layout-preserving conversion needs an internet connection. We extracted the text instead.';
  }
  return 'The layout-preserving converter was unavailable, so we extracted the text only — formatting may be lost.';
}
